import { useTranslation } from "react-i18next";
import { BaseNavigationBar, SettingsBackButton } from "@/lib/components/navigation";
import { PageContent } from "@/lib/components/page-content";
import { SettingsSearchTrigger } from "../../search/components/settings-search-trigger";
import { AppearanceForm } from "./appearance-form";

export function AppearanceSettingsPage() {
  const { t } = useTranslation("settings");

  return (
    <>
      <BaseNavigationBar
        title={t("sections.appearance.title")}
        subtitle={t("sections.appearance.description")}
        backButton={<SettingsBackButton />}
        trailingElements={[<SettingsSearchTrigger key="search-trigger" />]}
      />

      <PageContent>
        <div className="space-y-6">
          <AppearanceForm />
        </div>
      </PageContent>
    </>
  );
}
